import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.DashboardFilter.';
  public static readonly filterData = `${Id.prefix}filterData`;
  public static readonly selectDateRange = `${Id.prefix}selectDateRange`;
  public static readonly selectBranch = `${Id.prefix}selectBranch`;
  public static readonly selectUser = `${Id.prefix}selectUser`;
  public static readonly allBranches = `${Id.prefix}allBranches`;
  public static readonly allEmployees = `${Id.prefix}allEmployees`;
}

export class LangDashboardFilter {
  private constructor() {}
  public static filterData(): string {
    return interpolate(Id.filterData);
  }
  public static selectDateRange(): string {
    return interpolate(Id.selectDateRange);
  }
  public static selectBranch(): string {
    return interpolate(Id.selectBranch);
  }
  public static selectUser(): string {
    return interpolate(Id.selectUser);
  }
  public static allBranches(): string {
    return interpolate(Id.allBranches);
  }
  public static allEmployees(): string {
    return interpolate(Id.allEmployees);
  }
}

export class DashboardFilterModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.filterData, 'Filter Data', 'Label for dashboard filter section');
    register.add(Id.selectDateRange, 'Select Date Range', 'Placeholder for date range select');
    register.add(Id.selectBranch, "Select {{glossary 'branch'}}", 'Placeholder for branch select');
    register.add(Id.selectUser, 'Select User', 'Placeholder for user select');
    register.add(Id.allBranches, "{{glossary 'branch:plural'}}", 'Option for all branches');
    register.add(Id.allEmployees, 'All Employees', 'Option for all employees');
  }
}
